import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getNonOrder(params) {
	return client.get("api/product-stock/data-trx-non-order", {
		params: params,
	});
}

function getNonOrderAll(params) {
	return client.get("api/product-stock/data-trx-non-order-all", {
		params: params,
	});
}

function getNonOrderWaiting(params) {
	return client.get("api/product-stock/data-trx-non-order-waiting", {
		params: params,
	});
}

function getDetailNonOrder(params) {
	return client.get("api/product-stock/detail-trx-non-order", {
		params: {
			code : params
		},
	});
}

function exportNonOrder(params) {
	return client.get("api/product-stock/export-trx-non-order", {
		params: params,
	});
}

function exportNonOrderAll(params) {
	return client.get("api/product-stock/export-trx-non-order-all", {
		params: params,
	});
}

function createNonOrder (params) {
	return client.post("api/product-stock/stock-trx-non-order", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function approveNonOrder (params) {
	return client.post("api/product-stock/approve-trx-non-order", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function cancelNonOrder (params) {
	return client.post("api/product-stock/cancel-trx-non-order", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getNonOrder,
	getNonOrderAll,
	getNonOrderWaiting,
	getDetailNonOrder,
	exportNonOrder,
	exportNonOrderAll,
	createNonOrder,
	approveNonOrder,
	cancelNonOrder,
};